import { render, staticRenderFns } from "./dynamicdetails.vue?vue&type=template&id=6ed8265e&scoped=true&"
import script from "./dynamicdetails.vue?vue&type=script&lang=js&"
export * from "./dynamicdetails.vue?vue&type=script&lang=js&"
import style0 from "./dynamicdetails.vue?vue&type=style&index=0&id=6ed8265e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed8265e",
  null
  
)

export default component.exports